module.exports = __webpack_public_path__ + "static/pattern-29a7043d9c07e33d4842d73bf55ceda2.jpg";